import React, { useContext, useEffect, useState } from "react";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import InputForm from "../../../Components/InputForm/InputForm";
import DateForm from "../../../Components/DateForm/DateForm";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { LoaderContext } from "../../../Helpers/Context/Context";
import { useLocation } from "react-router-dom";
import notify from "../../../Helpers/ToastNotification";
import { APICall, HttpMethod } from "../../../Helpers/Network/APICalls";
import { getNomineeDetailsByMemberId } from "../../../Helpers/APIEndPoints/EndPoints";
import { GetDecryptedMemberIdFromLocalStorage } from "../../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { Decrypt } from "../../../Helpers/Cryptography/Crypto";

import "./NomineeDetailsView.css";


const NomineeDetails = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [griddata, setGridData] = useState([]);
  const [dataCount, setDataCount] = React.useState<number>(0);
  const [dashboardPageSize, setDashboardPageSize] = React.useState<number>(10);
  const [searchText, setSearchText] = React.useState<string>("");

  // const { state } = useLocation();
  // const memberid = state.id ? state.id : "";
  const location = useLocation();
  // const memberid = GetDecryptedMemberIdFromLocalStorage() || "";
  // console.log(memberid, "memberid NomineeDetails");

  const getGridData = async (memberid: any) => {
    showLoader();
    // let param = `${getNomineeDetailsByMemberId}/${memberid}`
    // const insertData = await APICall(param,{},HttpMethod.GET);

    let requestParams = { MemberId: memberid };
    const insertData = await APICall(
      getNomineeDetailsByMemberId,
      requestParams
    );

   
    if (insertData.Data != null) {
      let temp = [];
      insertData.Data.map((d) => {
        let data = {
          nomineename: d.Name,
          nomineerelations: d.Relationships,
          dob: d.DOB,
          EmailId: d.EmailId,
          ContactNo: d.ContactNo,
          nomineeminor: d.IsMinor,
          address: d.Address,
          share: d.SharePercentage,
          terms: d.IsAgreedTC,
        };
        temp.push(data);
      });

      setGridData(temp);
    } else {
      notify(1, "Data not found");
      hideLoader();
    }
  };

  useEffect(() => {
    debugger
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("memberid")) { // || params.has("hide")
        // let memberid = Decrypt(params.get("memberid"));
        // let encMemberId = decodeURI(params.get("memberid"));
        // let memberid = Decrypt(encMemberId);
        let encMemberId = params.get("memberid");
        // let memberid = decodeURIComponent(Decrypt(encMemberId));
        let decodeURLMember = decodeURIComponent(Decrypt(encMemberId));
        const parts = decodeURLMember.split('||');
        let memberid = parts[0];
        // let hide = params.get("hide");
        onLoadApiCall(memberid);
      }
    }
  }, [location.search]);

  const onLoadApiCall = async (memberid) => {
    showLoader();

    if (memberid != null && memberid != "") {
      await getGridData(memberid);
    } else {
      notify(1, "Something went wrong");
    }

    hideLoader();
  };

  // useEffect(() => {
  //   onLoadApiCall();
  // }, []);

  const dashboardOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: dashboardPageSize,
    serverSide: false,
    rowsPerPageOptions: [] as any[],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
  };
  const dashboardGridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
        filter: true,
        sort: true,
      },
    },
    {
      name: "nomineename",
      label: "Nominee Name",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "nomineerelations",
      label: "Nominee Relation",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "dob",
      label: "Date of Birth",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "EmailId",
      label: "Email Id",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "ContactNo",
      label: "Mobile No.",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "nomineeminor",
      label: "Is Nominee Minor",
      options: {
        filter: false,
        sort: true,
        // setCellProps: () => ({
        //   style: { textAlign: "center" },
        // }),
        // setCellHeaderProps: () => ({
        //   style: { textAlign: "center" },
        // }),
        customBodyRender: (value) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "share",
      label: "% Share",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    
  ];
  return (
    <>
      <div className="">
        <div className="page-content row filter-row-container "> 
          <div className="col-lg-12 p-0">
            <div className="row d-flex justify-content-end">
              <div className="col-lg-4 col-md-6 searchStyle">
                  {/* <div className="searchInput " >
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div> */}
                
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <DynamicGrid
            options={dashboardOptions}
            data={griddata}
            columns={dashboardGridColumns}
          />
        </div>
      </div>
    </>
  );
};

export default NomineeDetails;
